import 'semantic-ui-css/semantic.min.css';
import React from "react";
import ReactDOM from "react-dom";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import { createStore, applyMiddleware, compose } from "redux";
import Login from "./components/Login.jsx";
import Home from "./components/Home.jsx";
import ControlPanel from "./components/ControlPanel.jsx"
import { Provider } from "react-redux";
import reduxThunk from "redux-thunk";
import reducers from "./reducers/index";
import { HashRouter, Route } from "react-router-dom";
import Throttle from "lodash/throttle";
import { loadState, saveState } from "./util"
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import Feedback from "./components/Feedback.jsx";

require('./styles/main.css')

const persistedState = loadState();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, persistedState, composeEnhancers(
  applyMiddleware(reduxThunk)
));
store.subscribe(Throttle(() => {
  saveState({
    auth: store.getState().auth,
  });
}, 1000));

const App = () =>
  <div style={{ height: "100%" }}>
    <Route path="/" exact component={Home} />
    <Route exact path="/home" component={Home} />
    <Route path="/login" component={Login} />
    <Route path="/controlpanel" component={ControlPanel} />
     <Route path="/feedback/:token" component={Feedback} />
  </div>;

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  </ErrorBoundary>,


  document.getElementById("app")
);
